export default class AnalyticsJI {
    constructor(appName, version, os) {
        this.appName = appName;
        this.version = version;
        this.os = os;
        this.sessionid = null;
        this.uuid = null;
        this.mode = null;
    }
    StorageAvailable(type) {
        try {
            var storage = window[type],
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    GetUserID() {
        let uuid = null;

        //try using cordova
        if (typeof device !== "undefined" && device.uuid !== "undefined") {
            uuid = device.uuid;
        }

        //if device id not exist create one and save it
        if (uuid === null && this.StorageAvailable('localStorage')) {
            uuid = localStorage.getItem("uuid");
            if (uuid === null) {
                uuid = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;//get random number:Math.floor(Math.random() * (max - min + 1)) + min;
                localStorage.setItem('uuid', uuid);
            }
        }
        //else just give it an id
        if (uuid === null) {
            uuid = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;//get random number:Math.floor(Math.random() * (max - min + 1)) + min;
        }

        return uuid;

    }
    GetSessionID() {
        let sessionid = null;
        //get session id
        if (sessionid === null && this.StorageAvailable('sessionStorage')) {
            sessionid = sessionStorage.getItem("sessionid");
            if (sessionid === null) {
                sessionid = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;//get random number:Math.floor(Math.random() * (max - min + 1)) + min;
                sessionStorage.setItem('sessionid', sessionid);
            }
        }
        if (sessionid === null) {
            sessionid = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;//get random number:Math.floor(Math.random() * (max - min + 1)) + min;
        }
        return sessionid;
    }
    SetUuid(uuid) {
        if (!uuid) return;
        this.uuid = uuid;
        //save uuid to local storage
        if (this.StorageAvailable('localStorage')) {
            localStorage.setItem('uuid', uuid);
        }
    };
    SetMode(mode) {
        if (mode) this.mode = mode;
    };
    TrackStart() {
        this.Track("Start");
    };
    TrackPage(page, urlParameters) {
        this.Track("PageView", page, urlParameters);
    };
    TrackError(message, source, lineno, colno, error, logs) {
        let stack = "";
        if (error && error.stack) stack = error.stack;
        let log = "";
        if (logs) log = logs.join(", ");

        let details = `error ${error} : stack ${stack} : source ${source} : lineno ${lineno} : colno ${colno} : logs ${log}`;

        details = details.substr(0, 1500);

        //get uuid incase it never loaded
        if (!this.os) this.os = this.getOS();
        if (!this.uuid) this.uuid = this.GetUserID();
        if (!this.sessionid) this.sessionid = this.GetSessionID();

        this.Track("Error", message, details);
    }
    Track(Event, parameter1, parameter2) {

        //get uuid incase it never loaded
        if (!this.os) this.os = this.getOS();
        if (!this.uuid) this.uuid = this.GetUserID();
        if (!this.sessionid) this.sessionid = this.GetSessionID();

        var appName = this.appName;
        var version = this.version;
        var os = this.os;
        var uuid = this.uuid;
        var sessionid = this.sessionid;
        var mode = this.mode;

        //get CurrentCulture
        var currentCulture = window.navigator.userLanguage || window.navigator.language;//works IE/SAFARI/CHROME/FF

        this.SendData(appName, version, Event, parameter1, parameter2, currentCulture, sessionid, uuid, os, mode);
    };
    getOS() {
        let ua = navigator.userAgent;
        let isCordova = typeof cordova != "undefined";

        const isOnDiscord = window.location.host.includes("discord");
        if (isOnDiscord) {
            return "discord";
        }

        //var url = window && window.location && window.location.href && window.location.href || "";
        if (typeof FBInstant !== "undefined") {
            return "FBMessenger";
        }

        if (/(Windows Phone.*MSAppHost\/3.0)/i.test(navigator.appVersion)) {
            // Windows 10 UWP
            return "windowsPhone";
        }
        if (/(MSAppHost\/3.0)/i.test(navigator.appVersion)) {
            // Windows 10 UWP
            return "windows";
        }

        let isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFS‌​AW|KFSOWI|KFTBW|KFTH‌​W|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);
        if (isCordova && /(android)/i.test(navigator.userAgent) && isKindle) {
            return "amazon";
        }
        if (isCordova && /(android)/i.test(navigator.userAgent) && !isKindle) {
            return "android";
        }
        if (isCordova && (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel')) {
            return "ios";
        }
        //pwa + edg = Edge
        const isInStandaloneMode = (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
        if (isInStandaloneMode && /(Edg)/i.test(navigator.userAgent)) {
            return "windowsPWA";
        }
        return "web";
    }

    SendData(AppName, Version, Event, parameter1, parameter2, CurrentCulture, SessionID, DeviceUniqueID, OS, mode, UrlReferrer) {

        //send data
        var xmlHttp = null;
        var theUrl = "https://analytics.jdsoftwarellc.com/Service.svc/LogEvent?";

        //if discord use server proxy
        if (window.location.host.includes("discord")) {
            theUrl = "/.proxy/analytics?";
        }


        // if (window.location.protocol === "http:")
        //     theUrl = "http://analytics.jdsoftwarellc.com/WP7/Service.svc/LogEvent?";

        //if undefined return string
        if (!CurrentCulture) CurrentCulture = "";
        if (!DeviceUniqueID) DeviceUniqueID = "";
        if (!SessionID) SessionID = "";
        if (!Version) Version = "";
        if (!parameter1) parameter1 = "";
        if (!parameter2) parameter2 = "";
        //if (!LiveAnonymousID) LiveAnonymousID = "";
        if (!mode) mode = "";
        if (!UrlReferrer) {
            UrlReferrer = (window.location != window.parent.location) ? document.referrer : document.location.href;
        }

        CurrentCulture = encodeURIComponent(CurrentCulture);
        DeviceUniqueID = encodeURIComponent(DeviceUniqueID);
        SessionID = encodeURIComponent(SessionID);
        Version = encodeURIComponent(Version);
        parameter1 = encodeURIComponent(parameter1);
        parameter2 = encodeURIComponent(parameter2);
        OS = encodeURIComponent(OS);
        mode = encodeURIComponent(mode);

        theUrl = theUrl + "AppName=" + AppName
            + "&Event=" + Event
            + "&Culture=" + CurrentCulture
            + "&DeviceUniqueID=" + DeviceUniqueID
            + "&SessionID=" + SessionID
            + "&Version=" + Version
            + "&Parameter1=" + parameter1
            + "&Parameter2=" + parameter2
            + "&LiveAnonymousID=" //+ LiveAnonymousID
            + "&OS=" + OS
            + "&Mode=" + mode
            + "&UrlReferrer=" + UrlReferrer 
            + "&Random=" + Math.floor(Math.random() * 1000000);

        try {
            xmlHttp = new XMLHttpRequest();
            xmlHttp.open("GET", theUrl, true);
            xmlHttp.send(null);
        } catch (ex) {
            //log error, but in this case we dont care
            var error = ex;
        }

    }
}


